import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  languages = ['fi', 'en'];
  currentLanguage = 'fi';
  languageChangedSubject: Subject<string>;

  constructor(
    private userService: UserService,
    private translate: TranslateService,
  ) {
    this.languageChangedSubject = new Subject<string>();
  }

  getLanguage = () => this.currentLanguage;

  setLanguage = (language: string) => {
    if (this.languages.includes(language)) {
      this.currentLanguage = language;
      this.userService.setUserLanguage(language);
      this.translate.use(language);
      document.getElementsByTagName('html')[0].setAttribute('lang', language);
      this.languageChangedSubject.next(language);
    } else {
      console.log('Could not set language', language);
    }
  };

  getLanguages = () => this.languages;

  getInitialLanguage = () => {
    let userLang = navigator.language.split('-')[0];
    const urlFragments = window.location.href.split('/');
    urlFragments.forEach((fragment) => {
      if (fragment && fragment === 'fi') {
        userLang = 'fi';
      } else if (fragment && fragment === 'en') {
        userLang = 'en';
      }
    });
    if (!this.userService.user) {
      this.userService.restoreUserFromLocalStorage();
    }
    if (this.userService.user && this.userService.user.language) {
      userLang = this.userService.user.language;
    }
    if (userLang === 'en' || userLang === 'fi') {
      this.currentLanguage = userLang;
    } else {
      this.currentLanguage = 'en';
    }
    return this.currentLanguage;
  };
}
